import { React, useState } from 'react';
import "./landingpage.css"
import ProfileImage from '../assets/images/profileImg.png';
const ContactForm = () => {

    return (
        <div className='p-5'>
            <div className='row'>
                <div className='col-4'>
                    <div className='ContactHead'>CONTACT US</div>
                    <div className='formBox mt-3 p-3'>
                        <div className='info pb-3'>Enter your Info</div>
                        <div>
                            <input
                                type='text'
                                className='form-control'
                                id='validationCustom01'
                                placeholder='Full Name'
                            />
                        </div>
                        <div className='pt-3'>
                            <input
                                type='email'
                                className='form-control'
                                id='validationCustom01'
                                placeholder='Email'
                            />
                        </div>
                        <div className='py-3'>
                            <input
                                type='number'
                                className='form-control'
                                id='validationCustom01'
                                placeholder='Phone Number'
                            />
                        </div>
                        <div>
                            <input
                                type='text'
                                className='form-control'
                                id='validationCustom01'
                                placeholder='State'
                            />
                        </div>
                        <div className='orderBtn mt-3'>
                            Send Message
                        </div>
                    </div>
                </div>
                <div className='col-8 end'>
                    <div className='MessageImg'>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
